import { useIsIpcReady } from '@highlight/ipc/react'
import { initializeAmplitude } from '@renderer/utils/amplitude.renderer.ts'
import { initializeAnalytics } from '@renderer/utils/analytics.renderer.ts'

/**
 * This hook ensures the renderer is synchronized with the main process across
 * global states and stores that rely on async IPC calls for initialization.
 *
 * If this isn't called somewhere in the component tree, you cannot guarantee that
 * initial states or listeners for updates will function as expected.
 *
 * @return boolean
 */
/**
 * Module scope, not an inline arrow. `useIsIpcReady` lists this in an effect's
 * dependencies, so a new identity each render re-runs the effect and attaches
 * another `then` to the sync promise, initializing analytics once per render
 * that happened before IPC finished syncing.
 */
const initializeRendererTelemetry = () => {
  initializeAmplitude()
  initializeAnalytics()
}

export const useIsRendererReady = () => {
  return useIsIpcReady(initializeRendererTelemetry)
}
